import { createGlobalStyle } from 'styled-components/macro';

const GlobalFontStyle = createGlobalStyle`
 * {
    font-family: 'Inter', sans-serif;
  }
`;

export default GlobalFontStyle;
